import { AxiosRequestConfig } from 'axios';
import API from '../API';
import CustomerAddress from '../../models/CustomerAddress';

export const getContactAddress = (
  urlParams: { addressType: 'CONTACT' | 'RESIDENTIAL', customerId: number },
  queryParams: Record<string, unknown> = {},
  options: AxiosRequestConfig = {},
) => API.makeGetRequest(
  `/address/${urlParams.addressType}/${urlParams.customerId}`, queryParams, options,
) as Promise<CustomerAddress>;

export const saveAddress = (
  body: Partial<CustomerAddress>,
  options: AxiosRequestConfig = {},
) => API.makePatchRequest(`/address`, body, {}, options);

export const deleteAddress = (pathParams: { addressId: number }) =>
  API.makeDeleteRequest(`/address/${pathParams.addressId}`, {});
